import { render, staticRenderFns } from "./WildcardFriend.vue?vue&type=template&id=1ac2ebcf&"
import script from "./WildcardFriend.vue?vue&type=script&lang=ts&"
export * from "./WildcardFriend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports